module.exports = __webpack_public_path__ + "static/media/Cornerstone_Logo.6a593351.png";